import { component } from "Agile/Scripts/Common/Components/ComponentRegistration";
import { DynamicPivotItem } from "Agile/Scripts/Common/Components/DynamicPivotItem";
import { LoadingComponent } from "Presentation/Scripts/TFS/Components/LoadingComponent";
import { ISprintViewPivotContext } from "Agile/Scripts/SprintsHub/SprintView/SprintContentViewContracts";
import { IContributedPivotProps } from "VSSPreview/Utilities/PivotContributions";
import * as React from "react";


export interface IAnalyticsPivotProps extends IContributedPivotProps<ISprintViewPivotContext, {}> { }

@component("work.sprintshub.analytics")
export class SprintAnalyticsPivotRegistration extends React.Component<IAnalyticsPivotProps> {
    public render(): JSX.Element {
        const { pivotContext } = this.props;

        return (
            <DynamicPivotItem
                dataProviders={[]}
                shouldReloadDataProviders={pivotContext.shouldReloadDataProviders}
                modules={["Agile/Scripts/SprintsHub/Analytics/SprintAnalyticsPivot"]}
                onRenderLoading={() => <LoadingComponent />}
                componentProps={pivotContext}
                componentKey="sprint-analytics-pivot"
            />
        );
    }
}
